"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @author: yangqianjun
 * @file: ajax封装
 * @Date: 2019-11-21 15:25:51
 * @LastEditors: yangqianjun
 * @LastEditTime: 2019-12-27 13:34:24
 */
var qs_1 = tslib_1.__importDefault(require("qs"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var axios_2 = tslib_1.__importStar(require("./axios"));
var consts_1 = require("./consts");
var testUser = typeof location !== 'undefined' && qs_1.default.parse(location.search.split('?')[1]).testUser;
var WrappedFetch = /** @class */ (function () {
    function WrappedFetch() {
    }
    /** ajax 方法 */
    WrappedFetch.prototype.ajax = function (_a, path, basePath) {
        var method = _a.method, url = _a.url, data = _a.data, form = _a.form, query = _a.query, header = _a.header, extra = _a.extra, cancel = _a.cancel, headers = _a.headers;
        var config = tslib_1.__assign(tslib_1.__assign({}, extra), { method: method.toLowerCase(), headers: tslib_1.__assign(tslib_1.__assign({}, headers), header) });
        if (testUser) {
            config.headers['Test-User'] = testUser;
        }
        // json
        if (data) {
            config = tslib_1.__assign(tslib_1.__assign({}, config), { headers: tslib_1.__assign(tslib_1.__assign({}, config.headers), { 'Content-Type': 'application/json' }), data: data });
        }
        // form
        if (form) {
            config = tslib_1.__assign(tslib_1.__assign({}, config), { headers: tslib_1.__assign(tslib_1.__assign({}, config.headers), { 'Content-Type': 'application/x-www-form-urlencoded' }), data: qs_1.default.stringify(form) });
        }
        var _b = consts_1.promiseFactory(), cancelRequest = _b[0].resolve, internalCancel = _b[1];
        config.cancelToken = new axios_1.default.CancelToken(function (c) {
            // 外部
            cancel && cancel.then(c, axios_2.emptyFunc);
            // 内部自动取消
            internalCancel.then(c, axios_2.emptyFunc);
        });
        var prom = axios_2.default
            .request(tslib_1.__assign(tslib_1.__assign({}, config), { url: testUser
                ? url.indexOf('?') === -1
                    ? url + "?testUser=" + testUser
                    : url.replace('?', function () { return "?testUser=" + testUser; })
                : url, params: query }))
            .then(function (res) { return res.data; })
            .catch(axios_2.onStatusError);
        // IMP: 修复 tkit/service 设计上的硬伤
        prom['cancel'] = cancelRequest;
        return prom;
    };
    /** 接口传参校验 */
    WrappedFetch.prototype.check = function (value, name) {
        if (value === null || value === undefined) {
            var msg = "[ERROR PARAMS]: " + name + " can't be null or undefined";
            // 非生产环境，直接抛出错误
            if (process.env.NODE_ENV === 'development') {
                throw Error(msg);
            }
        }
    };
    return WrappedFetch;
}());
exports.WrappedFetch = WrappedFetch;
exports.default = new WrappedFetch();
//# sourceMappingURL=new-ajax.js.map